import vTitle from './components/title'
import loadmore from './components/loadmore'
import datetime from './components/datetime'
import moment from 'moment';

const jump = url => {
    let {protocol,port,hostname} = window.location
    if(/^([0-9]{1,3}.){3}[0-9]{1,3}$/.test(hostname)){
        hostname = 'front.h5.sosho.cn';
    }
    window.location.href = protocol + "//" + hostname + url
}

const generate = (length = 32)=>{
    const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    let noceStr = '', maxPos = chars.length;
    while (length--) noceStr += chars[Math.random() * maxPos | 0];
    return noceStr;
}

function getScrollEventTarget(element) {
    let currentNode = element;
    while (currentNode && currentNode.tagName !== 'HTML' &&    
      currentNode.tagName !== 'BODY' && currentNode.nodeType === 1) {
      let overflowY = document.defaultView.getComputedStyle(currentNode).overflowY;
      if (overflowY === 'scroll' || overflowY === 'auto') {
        return currentNode;
      }
      currentNode = currentNode.parentNode;
    }
    return window;
}


let api = {
    install: function (Vue) {
        Vue.prototype.jump = jump;
        Vue.prototype.$generate = generate;
        Vue.prototype.$moment = moment
        Vue.component('v-title', vTitle)
        Vue.component('loadmore', loadmore) 
        Vue.component('datetime', datetime) 
        datetime      
        // Vue.directive('bottomMethod', {
        //     componentUpdated(el, binding){
        //         let dom = getScrollEventTarget(el)
        //         console.log(dom)
        //         let beforeScrollTop = 0
        //         let bindinged = false;
        //         $(dom).on('scroll',()=>{                  
        //             if(dom.scrollTop+dom.clientHeight>=dom.scrollHeight-10){
        //                 if (binding.value&&dom.scrollTop>beforeScrollTop&&!bindinged) {
        //                     console.log('出发了')
        //                     bindinged = true
        //                     binding.value()
        //                 }
        //             }
        //             beforeScrollTop = dom.scrollTop
        //         })
        //     }
        // })
    }
}

export default api


// WEBPACK FOOTER //
// ./src/api.js